export class AzureRestoreAccountConnectivityConfig {
    'vnetConfigurations';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vnetConfigurations",
            "baseName": "vnetConfigurations",
            "type": "Array<AzureVnetConnectivityConfig>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureRestoreAccountConnectivityConfig.attributeTypeMap;
    }
    constructor() {
    }
}
